module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-configuration', {
    attrs: {
      "data": _vm.config,
      "errors": _vm.errors
    }
  }, [_c('div', {
    staticClass: "l-row",
    attrs: {
      "slot": "auth"
    },
    slot: "auth"
  }, [_c('form-group', {
    attrs: {
      "label": "Ambiente",
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.environment),
      expression: "config.auth.environment"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.auth, "environment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "sandbox"
    }
  }, [_vm._v("Sandbox")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "production"
    }
  }, [_vm._v("Produção")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Identificação do Usuário"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.userId),
      expression: "config.auth.userId"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.config.auth.userId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "userId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Chave da API"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.apiKey),
      expression: "config.auth.apiKey"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.config.auth.apiKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "apiKey", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "API V2"
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Utilizar API V2 de integração"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.useAPIV2),
      expression: "config.auth.useAPIV2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.auth.useAPIV2) ? _vm._i(_vm.config.auth.useAPIV2, null) > -1 : (_vm.config.auth.useAPIV2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.auth.useAPIV2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.auth, "useAPIV2", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.auth, "useAPIV2", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.auth, "useAPIV2", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Utilizar nova API Dafiti. Configura seus dados de API(chave, senha) * Ative apenas após atualizar seus dados da API corretamente")])])], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Produtos"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingProducts
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('product-price-configuration', {
    attrs: {
      "input": _vm.config.product.price
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Redutor de estoque padrão"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.stock.reducer),
      expression: "config.product.stock.reducer"
    }],
    staticClass: "form-input",
    attrs: {
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.product.stock.reducer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.product.stock, "reducer", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.origins.length) ? _c('form-group', {
    attrs: {
      "label": "Origem"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.origin),
      expression: "config.product.origin"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.product, "origin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.origins), function(origin) {
    return _c('option', {
      domProps: {
        "value": origin
      }
    }, [_vm._v(_vm._s(origin))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.originsCountry.length) ? _c('form-group', {
    attrs: {
      "label": "País de Origem"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.originCountry),
      expression: "config.product.originCountry"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.product, "originCountry", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.originsCountry), function(originCountry) {
    return _c('option', {
      domProps: {
        "value": originCountry
      }
    }, [_vm._v(_vm._s(originCountry))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Redimensionar imagens"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.image.resize),
      expression: "config.product.image.resize"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.product.image, "resize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.resizeImageOptions), function(resizeImageOption) {
    return _c('option', {
      domProps: {
        "value": resizeImageOption
      }
    }, [_vm._v(_vm._s(_vm.$t((resizeImageOption + ".label"))))])
  }), 0)]), _vm._v(" "), (_vm.config.product.image.resize) ? _c('form-group', {
    attrs: {
      "label": "Identificador da conta"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.identifier),
      expression: "config.auth.identifier"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.config.auth.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "identifier", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("O identificador da conta é igual ao nome do seu dominio.")]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("No exemplo: \"www.placemarket.com.br\" o identificador da conta seria \"placemarket\".")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('expediter.label')
    }
  }, [_c('expediter-configuration', {
    attrs: {
      "expediter": _vm.config.order.expediter
    }
  })], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('order.label')
    }
  }, [_c('order-retrieve-date-configuration', {
    attrs: {
      "orderConfigs": _vm.config.order
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "columns": _vm.columns || 2,
      "label": "Sincronizar parcelas"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.syncInstallments),
      expression: "config.order.syncInstallments"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.order, "syncInstallments", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.syncInstallmentsOptions), function(syncInstallmentsOption) {
    return _c('option', {
      domProps: {
        "value": syncInstallmentsOption
      }
    }, [_vm._v(_vm._s(_vm.$t((syncInstallmentsOption + ".label"))))])
  }), 0)])], 1)], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Serviço de entrega"
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Utiliza Dafiti Envios"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.shipmentService),
      expression: "config.order.shipmentService"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.order, "shipmentService", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.shipmentServiceOptions), function(shipmentServiceOption) {
    return _c('option', {
      domProps: {
        "value": shipmentServiceOption
      }
    }, [_vm._v(_vm._s(_vm.$t((shipmentServiceOption + ".label"))))])
  }), 0)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d399377","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Configuration/Gfg.vue
// module id = 2901
// module chunks = 0